/**
 * Shifts cursor in inputs/textareas/etc to the right on focus
 */
export default function shiftInputCursor(e) {
  const tmp = e.target.value;
  e.target.value = '';
  e.target.value = tmp;
}
